var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassword(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_20782_77669)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7501 6.64222C13.9802 6.64222 14.1667 6.45568 14.1667 6.22556C14.1667 5.99544 13.9802 5.80889 13.7501 5.80889C13.52 5.80889 13.3334 5.99544 13.3334 6.22556C13.3334 6.45568 13.52 6.64222 13.7501 6.64222Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.15508 14.4872C1.8425 14.7997 1.66684 15.2236 1.66675 15.6656V17.4756C1.66675 17.6966 1.75455 17.9085 1.91083 18.0648C2.06711 18.2211 2.27907 18.3089 2.50008 18.3089H5.00008C5.22109 18.3089 5.43306 18.2211 5.58934 18.0648C5.74562 17.9085 5.83341 17.6966 5.83341 17.4756V16.6422C5.83341 16.4212 5.92121 16.2092 6.07749 16.053C6.23377 15.8967 6.44573 15.8089 6.66675 15.8089H7.50008C7.72109 15.8089 7.93306 15.7211 8.08934 15.5648C8.24562 15.4085 8.33341 15.1966 8.33341 14.9756V14.1422C8.33341 13.9212 8.42121 13.7092 8.57749 13.553C8.73377 13.3967 8.94573 13.3089 9.16675 13.3089H9.31008C9.75207 13.3088 10.1759 13.1331 10.4884 12.8206L11.1667 12.1422C12.3249 12.5457 13.5858 12.5441 14.743 12.1378C15.9002 11.7316 16.8853 10.9446 17.537 9.90566C18.1888 8.86673 18.4688 7.63737 18.331 6.41867C18.1933 5.19998 17.646 4.0641 16.7788 3.19686C15.9115 2.32963 14.7757 1.78238 13.557 1.64463C12.3383 1.50689 11.1089 1.7868 10.07 2.43859C9.03105 3.09038 8.24407 4.07545 7.83779 5.23266C7.4315 6.38986 7.42996 7.65069 7.83341 8.80889L2.15508 14.4872Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.7501 6.64222C13.9802 6.64222 14.1667 6.45568 14.1667 6.22556C14.1667 5.99544 13.9802 5.80889 13.7501 5.80889C13.52 5.80889 13.3334 5.99544 13.3334 6.22556C13.3334 6.45568 13.52 6.64222 13.7501 6.64222Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_20782_77669"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassword);
export default __webpack_public_path__ + "static/media/Password.f89ae3815e4898e80cafb41194558f24.svg";
export { ForwardRef as ReactComponent };